<template>
    <v-app id="login">
        <v-container tag="section">
            <v-layout align-center justify-end class="mx-auto" style="max-width: 1200px">
                <LoginForm />
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { AUTH_LOGIN } from '../../store/mutation-types';
import LoginForm from '@/components/forms/LoginForm.vue';

export default {
  name: 'Login',
  components: {LoginForm},
};
</script>

<style scoped>

</style>
